import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-expense-transaction-list',
  templateUrl: './expense-transaction-list.component.html',
  styleUrls: ['./expense-transaction-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseTransactionListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  constructor(
    private transactionService: TransactionService,
    private router: Router,
    public authService: AuthService) { }

  async ngOnInit() {
    const transactionAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllExpenseList');
    if (transactionAuthorization) {
      await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }
  }

  onActivate(event: any) {
    const transactionAuthorization = this.authService.isEndpointStatus('GET.Reading.UpdateByIdDetailTransactions');
    if (transactionAuthorization) {
      if (event.type === 'click' && event.row) {
        console.log(event.row);
        if (event.row.companyId == 2) {
          this.router.navigate([`/admin/mexpensetransaction-update/${event.row.id}`]);
        } else {
          this.router.navigate([`/admin/buying-detail/${event.row.id}`]);
        }
      }
    }
  }

  async getAllTransaction(page, size, search) {
    this.blockUI.start('Masraflar yükleniyor..')
    const data = await this.transactionService.GetTransactionManagementExpenseList(page, size, search);
    console.log(data);
    this.totalCount = data.totalCount;
    this.rows = data.expenseListTransactions;
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async exportExcel() {
    await this.getAllTransaction(this.pageBasic - 1, this.selectedSize, this.searchValue);
    const exportedData = [];
    this.rows.forEach(item => {
      const rowData = {
        'Döküman No': item.documentNo ?? item.no,
        'Satış Fiyatı': item.transactionProducts[0].productPrice ?? 0,
        'KDV': item.transactionProducts[0].taxRate ?? 0,
        'İşlem Tarihi': item.transactionCraetedAt,
        'Masraf Türü': item.expenseTransactions[0].name,
        'Proje': item.projects[0]?.name,
        'Açıklama': item.transactionPrivateNode
      };
      exportedData.push(rowData);
    });
    return exportedData;
  }

  async exportAsExcelFile() {
    const data = await this.exportExcel();
    if (data.length > 0) {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'masraflistesi.xlsx');
    } else { }
  }

  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(data, baseFileName);
  }
}